export const openKindly = () => {
    const DIALOGUE_ID = '19e5b38f-3b45-42b9-a99c-7f35c3caff8a';
    if (window.kindlyChat && window.kindlyChat.openChat) {
        window.kindlyChat.openChat();
    } else {
        window.addEventListener('kindly:load', function once() {
            if (window.kindlyChat) {
                window.kindlyChat.openChat();
            }
        }, { once: true });
    }
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event: 'kindly_open_click', dialogue_id: DIALOGUE_ID });
};

export function isOpenChatbotHref(href: string): boolean {
    return href.toLowerCase().includes('#openchat');
}
